import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _bulkCreateVariantsRequest = { variants: '_variant' };
var _bulkCreateVariantsResponse = { results: '_bulkVariantResult' };
var _bulkDeleteVariantsRequest = {};
var _bulkDeleteVariantsResponse = {};
var _bulkUpdateVariantsRequest = { variants: '_maskedVariant' };
var _bulkUpdateVariantsResponse = { results: '_bulkVariantResult' };
var _bulkVariantResult = { variant: '_variant' };
var _cloneVariantsRequest = {};
var _cloneVariantsResponse = {};
var _countVariantsRequest = {};
var _countVariantsResponse = {};
var _createVariantRequest = { variant: '_variant' };
var _createVariantResponse = { variant: '_variant' };
var _deleteVariantRequest = {};
var _deleteVariantResponse = {};
var _getVariantRequest = {};
var _getVariantResponse = { variant: '_variant' };
var _listVariantsRequest = {};
var _listVariantsResponse = { variants: '_variant' };
var _maskedVariant = {
    fieldMask: 'google.protobuf.FieldMask',
    variant: '_variant',
};
var _queryVariantsRequest = {};
var _queryVariantsResponse = { variants: '_variant' };
var _updateVariantRequest = {
    fieldMask: 'google.protobuf.FieldMask',
    variant: '_variant',
};
var _updateVariantResponse = { variant: '_variant' };
var _variant = {
    createdDate: 'google.protobuf.Timestamp',
    updatedDate: 'google.protobuf.Timestamp',
};
function resolveWixRestaurantsMenusItemVariantV1VariantsServiceUrl(opts) {
    var domainToMappings = {
        'manage._base_domain_': [
            {
                srcPath: '/_api/restaurants-menus-item-variant',
                destPath: '',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/restaurants-menus-item-variant',
                destPath: '',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/restaurants-menus-item-variant',
                destPath: '',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/restaurants-menus-item-variant',
                destPath: '',
            },
        ],
        'editor.wixapps.net': [
            {
                srcPath: '/_api/restaurants-menus-item-variant',
                destPath: '',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/restaurants-menus-item-variant',
                destPath: '',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/restaurants-menus-item-variant',
                destPath: '',
            },
        ],
        _: [
            {
                srcPath: '/_api/restaurants-menus-item-variant',
                destPath: '',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/restaurants/item-variants',
                destPath: '',
            },
        ],
        'api._api_base_domain_': [
            {
                srcPath: '/restaurants-menus-item-variant',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/**
 * > **Note:** The Item Variants API only works with the Wix Restaurants Menus (New) app. Make sure you have installed this app from the [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
 *
 * Creates an item variant.
 *
 * To create multiple item variants at once, use [Bulk Create Variants](https://dev.wix.com/docs/rest/business-solutions/restaurants/menus/item-variant/bulk-create-variants).
 */
export function createVariant(payload) {
    var _a = serializer(_createVariantRequest, { _variant: _variant }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createVariantResponse, {
        _variant: _variant,
    }).fromJSON;
    function __createVariant(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.menus.v1.item_variant',
            method: 'POST',
            methodFqn: 'wix.restaurants.menus_item_variant.v1.VariantsService.CreateVariant',
            url: resolveWixRestaurantsMenusItemVariantV1VariantsServiceUrl({
                protoPath: '/v1/variants',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createVariant.fromReq = fromReq;
    __createVariant.__isAmbassador = true;
    return __createVariant;
}
/**
 * > **Note:** The Item Variants API only works with the Wix Restaurants Menus (New) app. Make sure you have installed this app from the [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
 *
 * Retrieves an item variant by ID.
 */
export function getVariant(payload) {
    var _a = serializer(_getVariantRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getVariantResponse, { _variant: _variant }).fromJSON;
    function __getVariant(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.menus.v1.item_variant',
            method: 'GET',
            methodFqn: 'wix.restaurants.menus_item_variant.v1.VariantsService.GetVariant',
            url: resolveWixRestaurantsMenusItemVariantV1VariantsServiceUrl({
                protoPath: '/v1/variants/{variantId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getVariant.fromReq = fromReq;
    __getVariant.__isAmbassador = true;
    return __getVariant;
}
/**
 * > **Note:** The Item Variants API only works with the Wix Restaurants Menus (New) app. Make sure you have installed this app from the [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
 *
 * Retrieves a list of up to 100 item variants.
 */
export function listVariants(payload) {
    var _a = serializer(_listVariantsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listVariantsResponse, { _variant: _variant }).fromJSON;
    function __listVariants(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.menus.v1.item_variant',
            method: 'GET',
            methodFqn: 'wix.restaurants.menus_item_variant.v1.VariantsService.ListVariants',
            url: resolveWixRestaurantsMenusItemVariantV1VariantsServiceUrl({
                protoPath: '/v1/variants',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listVariants.fromReq = fromReq;
    __listVariants.__isAmbassador = true;
    return __listVariants;
}
/**
 * > **Note:** The Item Variants API only works with the Wix Restaurants Menus (New) app. Make sure you have installed this app from the [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
 *
 * Updates an item variant.
 *
 * To update multiple item variants at once, use [Bulk Update Variants](https://dev.wix.com/docs/rest/business-solutions/restaurants/menus/item-variant/bulk-update-variants).
 *
 * Each time an item variant is updated, its revision increments by 1. The existing revision must be included when updating the variant. This ensures you're working with the latest variant information, and it prevents unintended overwrites.
 */
export function updateVariant(payload) {
    var _a = serializer(_updateVariantRequest, { _variant: _variant }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateVariantResponse, {
        _variant: _variant,
    }).fromJSON;
    function __updateVariant(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.menus.v1.item_variant',
            method: 'PATCH',
            methodFqn: 'wix.restaurants.menus_item_variant.v1.VariantsService.UpdateVariant',
            url: resolveWixRestaurantsMenusItemVariantV1VariantsServiceUrl({
                protoPath: '/v1/variants/{variant.id}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateVariant.fromReq = fromReq;
    __updateVariant.__isAmbassador = true;
    return __updateVariant;
}
/**
 * > **Note:** The Item Variants API only works with the Wix Restaurants Menus (New) app. Make sure you have installed this app from the [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
 *
 * Creates multiple item variants.
 */
export function bulkCreateVariants(payload) {
    var _a = serializer(_bulkCreateVariantsRequest, { _variant: _variant }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkCreateVariantsResponse, {
        _bulkVariantResult: _bulkVariantResult,
        _variant: _variant,
    }).fromJSON;
    function __bulkCreateVariants(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.menus.v1.item_variant',
            method: 'POST',
            methodFqn: 'wix.restaurants.menus_item_variant.v1.VariantsService.BulkCreateVariants',
            url: resolveWixRestaurantsMenusItemVariantV1VariantsServiceUrl({
                protoPath: '/v1/bulk/variants/create',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkCreateVariants.fromReq = fromReq;
    __bulkCreateVariants.__isAmbassador = true;
    return __bulkCreateVariants;
}
/**
 * > **Note:** The Item Variants API only works with the Wix Restaurants Menus (New) app. Make sure you have installed this app from the [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
 *
 * Updates multiple item variants.
 *
 * Each time an item variant is updated, its revision increments by 1. The existing revision must be included when updating variant. This ensures you're working with the latest item information, and it prevents unintended overwrites.
 *
 * Up to 100 item variants can be returned per request.
 */
export function bulkUpdateVariants(payload) {
    var _a = serializer(_bulkUpdateVariantsRequest, { _maskedVariant: _maskedVariant, _variant: _variant }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkUpdateVariantsResponse, {
        _bulkVariantResult: _bulkVariantResult,
        _variant: _variant,
    }).fromJSON;
    function __bulkUpdateVariants(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.menus.v1.item_variant',
            method: 'POST',
            methodFqn: 'wix.restaurants.menus_item_variant.v1.VariantsService.BulkUpdateVariants',
            url: resolveWixRestaurantsMenusItemVariantV1VariantsServiceUrl({
                protoPath: '/v1/bulk/variants/update',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkUpdateVariants.fromReq = fromReq;
    __bulkUpdateVariants.__isAmbassador = true;
    return __bulkUpdateVariants;
}
/**
 * > **Note:** The Item Variants API only works with the Wix Restaurants Menus (New) app. Make sure you have installed this app from the [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
 *
 * Permanently deletes an item variant.
 */
export function deleteVariant(payload) {
    var _a = serializer(_deleteVariantRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_deleteVariantResponse, {}).fromJSON;
    function __deleteVariant(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.menus.v1.item_variant',
            method: 'DELETE',
            methodFqn: 'wix.restaurants.menus_item_variant.v1.VariantsService.DeleteVariant',
            url: resolveWixRestaurantsMenusItemVariantV1VariantsServiceUrl({
                protoPath: '/v1/variants/{variantId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __deleteVariant.fromReq = fromReq;
    __deleteVariant.__isAmbassador = true;
    return __deleteVariant;
}
/**
 * > **Note:** The Item Variants API only works with the Wix Restaurants Menus (New) app. Make sure you have installed this app from the [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
 *
 * Retrieves a list of item variants given the provided paging, filtering, and sorting. Up to 100 item variants can be returned per request.
 *
 * For a detailed list of supported operations, see the [Supported Filters and Sorting](https://dev.wix.com/docs/rest/business-solutions/restaurants/menus/item-variant/supported-filters-and-sorting) article. To learn how to query item variants, see [API Query Language](https://dev.wix.com/docs/rest/articles/getting-started/api-query-language)
 */
export function queryVariants(payload) {
    var _a = serializer(_queryVariantsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryVariantsResponse, {
        _variant: _variant,
    }).fromJSON;
    function __queryVariants(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.menus.v1.item_variant',
            method: 'POST',
            methodFqn: 'wix.restaurants.menus_item_variant.v1.VariantsService.QueryVariants',
            url: resolveWixRestaurantsMenusItemVariantV1VariantsServiceUrl({
                protoPath: '/v1/variants/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryVariants.fromReq = fromReq;
    __queryVariants.__isAmbassador = true;
    return __queryVariants;
}
/**
 * > **Note:** The Item API only works with the Wix Restaurants Menus (New) app. Make sure you have installed this app from the [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
 *
 * Retrieves the number of item variants that match a specified filter.
 *
 * If a filter isn't passed in the request, the endpoint returns the count of all item variants.
 */
export function countVariants(payload) {
    var _a = serializer(_countVariantsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_countVariantsResponse, {}).fromJSON;
    function __countVariants(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.menus.v1.item_variant',
            method: 'POST',
            methodFqn: 'wix.restaurants.menus_item_variant.v1.VariantsService.CountVariants',
            url: resolveWixRestaurantsMenusItemVariantV1VariantsServiceUrl({
                protoPath: '/v1/variants/count',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __countVariants.fromReq = fromReq;
    __countVariants.__isAmbassador = true;
    return __countVariants;
}
/** Clone item variants from a different metasite. */
export function cloneVariants(payload) {
    var _a = serializer(_cloneVariantsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_cloneVariantsResponse, {}).fromJSON;
    function __cloneVariants(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.menus.v1.item_variant',
            method: 'POST',
            methodFqn: 'wix.restaurants.menus_item_variant.v1.VariantsService.CloneVariants',
            url: resolveWixRestaurantsMenusItemVariantV1VariantsServiceUrl({
                protoPath: '/v1/variants/clone',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __cloneVariants.fromReq = fromReq;
    __cloneVariants.__isAmbassador = true;
    return __cloneVariants;
}
/**
 * > **Note:** The Item Variants API only works with the Wix Restaurants Menus (New) app. Make sure you have installed this app from the [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
 *
 * Deletes multiple item variants at once.
 */
export function bulkDeleteVariants(payload) {
    var _a = serializer(_bulkDeleteVariantsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkDeleteVariantsResponse, {}).fromJSON;
    function __bulkDeleteVariants(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.menus.v1.item_variant',
            method: 'DELETE',
            methodFqn: 'wix.restaurants.menus_item_variant.v1.VariantsService.BulkDeleteVariants',
            url: resolveWixRestaurantsMenusItemVariantV1VariantsServiceUrl({
                protoPath: '/v1/bulk/variants/delete',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkDeleteVariants.fromReq = fromReq;
    __bulkDeleteVariants.__isAmbassador = true;
    return __bulkDeleteVariants;
}
//# sourceMappingURL=http.impl.js.map